// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var ChartId$ReactHooksTemplate = require("./chartId.res.js");
var TableAttribute$ReactHooksTemplate = require("./tableAttribute.res.js");

function TableComponent(props) {
  var chartHeight = props.chartHeight;
  var attribute = props.attribute;
  var match = ChartId$ReactHooksTemplate.name(props.chartId);
  switch (match) {
    case "Digital Journey Wise Report" :
        return JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("table", {
                          children: [
                            JsxRuntime.jsx("thead", {
                                  children: JsxRuntime.jsxs("tr", {
                                        children: [
                                          JsxRuntime.jsx("th", {
                                                children: "Customer Journey",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Awareness",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Interest",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Consideration",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Signup",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Setup",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "First Use",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Customer Support",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Ongoing Use",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Upsell/Cross-Sell",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Feedback & Advocacy",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              })
                                        ]
                                      }),
                                  className: "bg-gray-100"
                                }),
                            JsxRuntime.jsxs("tbody", {
                                  children: [
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Overall SAT",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsxs("span", {
                                                        children: [
                                                          "60",
                                                          JsxRuntime.jsxs("svg", {
                                                                children: [
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M0 0h24v24H0z",
                                                                        stroke: "none"
                                                                      }),
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M18 15l-6-6l-6 6h12"
                                                                      })
                                                                ],
                                                                className: "h-8 w-8 text-green-500",
                                                                height: "24",
                                                                width: "24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: "2",
                                                                viewBox: "0 0 24 24"
                                                              })
                                                        ],
                                                        className: "inline-flex items-center space-x-1"
                                                      }),
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsxs("span", {
                                                        children: [
                                                          "70",
                                                          JsxRuntime.jsxs("svg", {
                                                                children: [
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M0 0h24v24H0z",
                                                                        stroke: "none"
                                                                      }),
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M18 15l-6-6l-6 6h12",
                                                                        transform: "rotate(180 12 12)"
                                                                      })
                                                                ],
                                                                className: "h-8 w-8 text-red-500",
                                                                height: "24",
                                                                width: "24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: "2",
                                                                viewBox: "0 0 24 24"
                                                              })
                                                        ],
                                                        className: "inline-flex items-center space-x-1"
                                                      }),
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsxs("span", {
                                                        children: [
                                                          "50",
                                                          JsxRuntime.jsxs("svg", {
                                                                children: [
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M0 0h24v24H0z",
                                                                        stroke: "none"
                                                                      }),
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M18 15l-6-6l-6 6h12"
                                                                      })
                                                                ],
                                                                className: "h-8 w-8 text-green-500",
                                                                height: "24",
                                                                width: "24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: "2",
                                                                viewBox: "0 0 24 24"
                                                              })
                                                        ],
                                                        className: "inline-flex items-center space-x-1"
                                                      }),
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsxs("span", {
                                                        children: [
                                                          "85",
                                                          JsxRuntime.jsxs("svg", {
                                                                children: [
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M0 0h24v24H0z",
                                                                        stroke: "none"
                                                                      }),
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M18 15l-6-6l-6 6h12",
                                                                        transform: "rotate(180 12 12)"
                                                                      })
                                                                ],
                                                                className: "h-8 w-8 text-red-500",
                                                                height: "24",
                                                                width: "24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: "2",
                                                                viewBox: "0 0 24 24"
                                                              })
                                                        ],
                                                        className: "inline-flex items-center space-x-1"
                                                      }),
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsxs("span", {
                                                        children: [
                                                          "65",
                                                          JsxRuntime.jsxs("svg", {
                                                                children: [
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M0 0h24v24H0z",
                                                                        stroke: "none"
                                                                      }),
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M18 15l-6-6l-6 6h12",
                                                                        transform: "rotate(180 12 12)"
                                                                      })
                                                                ],
                                                                className: "h-8 w-8 text-red-500",
                                                                height: "24",
                                                                width: "24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: "2",
                                                                viewBox: "0 0 24 24"
                                                              })
                                                        ],
                                                        className: "inline-flex items-center space-x-1"
                                                      }),
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsxs("span", {
                                                        children: [
                                                          "70",
                                                          JsxRuntime.jsxs("svg", {
                                                                children: [
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M0 0h24v24H0z",
                                                                        stroke: "none"
                                                                      }),
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M18 15l-6-6l-6 6h12"
                                                                      })
                                                                ],
                                                                className: "h-8 w-8 text-green-500",
                                                                height: "24",
                                                                width: "24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: "2",
                                                                viewBox: "0 0 24 24"
                                                              })
                                                        ],
                                                        className: "inline-flex items-center space-x-1"
                                                      }),
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsxs("span", {
                                                        children: [
                                                          "90",
                                                          JsxRuntime.jsxs("svg", {
                                                                children: [
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M0 0h24v24H0z",
                                                                        stroke: "none"
                                                                      }),
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M18 15l-6-6l-6 6h12",
                                                                        transform: "rotate(180 12 12)"
                                                                      })
                                                                ],
                                                                className: "h-8 w-8 text-red-500",
                                                                height: "24",
                                                                width: "24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: "2",
                                                                viewBox: "0 0 24 24"
                                                              })
                                                        ],
                                                        className: "inline-flex items-center space-x-1"
                                                      }),
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsxs("span", {
                                                        children: [
                                                          "55",
                                                          JsxRuntime.jsxs("svg", {
                                                                children: [
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M0 0h24v24H0z",
                                                                        stroke: "none"
                                                                      }),
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M18 15l-6-6l-6 6h12",
                                                                        transform: "rotate(180 12 12)"
                                                                      })
                                                                ],
                                                                className: "h-8 w-8 text-red-500",
                                                                height: "24",
                                                                width: "24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: "2",
                                                                viewBox: "0 0 24 24"
                                                              })
                                                        ],
                                                        className: "inline-flex items-center space-x-1"
                                                      }),
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsxs("span", {
                                                        children: [
                                                          "40",
                                                          JsxRuntime.jsxs("svg", {
                                                                children: [
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M0 0h24v24H0z",
                                                                        stroke: "none"
                                                                      }),
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M18 15l-6-6l-6 6h12"
                                                                      })
                                                                ],
                                                                className: "h-8 w-8 text-green-500",
                                                                height: "24",
                                                                width: "24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: "2",
                                                                viewBox: "0 0 24 24"
                                                              })
                                                        ],
                                                        className: "inline-flex items-center space-x-1"
                                                      }),
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: JsxRuntime.jsxs("span", {
                                                        children: [
                                                          "80",
                                                          JsxRuntime.jsxs("svg", {
                                                                children: [
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M0 0h24v24H0z",
                                                                        stroke: "none"
                                                                      }),
                                                                  JsxRuntime.jsx("path", {
                                                                        d: "M18 15l-6-6l-6 6h12",
                                                                        transform: "rotate(180 12 12)"
                                                                      })
                                                                ],
                                                                className: "h-8 w-8 text-red-500",
                                                                height: "24",
                                                                width: "24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: "2",
                                                                viewBox: "0 0 24 24"
                                                              })
                                                        ],
                                                        className: "inline-flex items-center space-x-1"
                                                      }),
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Overall Sentiment",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "Neutral",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "Positive",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "Neutral",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "Positive",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "Neutral",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "Positive",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "Positive",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "Negative",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-red-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "Negative",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-red-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "Positive",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-200"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Touchpoints",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "Social Media",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "Website",
                                                    JsxRuntime.jsx("br", {}),
                                                    "App Store"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "App Store Reviews",
                                                    JsxRuntime.jsx("br", {}),
                                                    "Blogs"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "Mobile App",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "Website",
                                                    JsxRuntime.jsx("br", {}),
                                                    "Mobile App",
                                                    JsxRuntime.jsx("br", {}),
                                                    "Email"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "Website",
                                                    JsxRuntime.jsx("br", {}),
                                                    "Mobile App"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "In-app Chat",
                                                    JsxRuntime.jsx("br", {}),
                                                    "Phone"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "Website",
                                                    JsxRuntime.jsx("br", {}),
                                                    "Mobile App",
                                                    JsxRuntime.jsx("br", {}),
                                                    "Notifications"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "Website",
                                                    JsxRuntime.jsx("br", {}),
                                                    "Mobile App",
                                                    JsxRuntime.jsx("br", {}),
                                                    "Email"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "Feeback Systems",
                                                    JsxRuntime.jsx("br", {}),
                                                    "App Store Reviews",
                                                    JsxRuntime.jsx("br", {}),
                                                    "Social Media"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Top Reasons for Promoters",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Clear Messaging and Branding",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Smooth Onboarding Experience",
                                                    "3.Engaging Content and Features"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Targeted and Relevant Offers",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.High-Quality Content",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Compelling Visuals and Calls to Action"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Product Comparisons and Testimonials",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Trust Signals",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Interactive Demos or Trials"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Quick and Easy Signup Process",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Social Media or One-Click Signups",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Clear Privacy and Data Policies"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Guided Setup Instructions",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Customizable Preferences",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Proactive Assistance (eg: Chatbots)"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Immediate Value",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Interactive Onboarding",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Personalization"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Responsive Support Channels",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Multiple Support Options (e.g., Chat, Phone)",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Self-Help Resources"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Regular Feature Updates",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Reliable Performance",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Personalized Experiences"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Relevant Product Suggestions",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Exclusive Offers",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Clear Value Addition"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Easy-to-Use Feedback Channels",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Recognition of Feedback",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Incentivized Advocacy"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Top Reasons for Detractors",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Confusing Layout or Overwhelming Design",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Slow Load Times or Glitches",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Lack of Trust Signals"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Overly Pushy Marketing",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Generic Content",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Unclear Value Proposition"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Complicated or Overwhelming Information",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Limited Customer Feedback",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Lack of Detailed Information"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Lengthy or Complex Signup Forms",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Hidden Costs or Subscription Fees",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.No Guest or Test Account Option"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Complicated Setup Process",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Poor Documentation or Help Resources",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Mandatory Configurations"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Overly Complex Interface",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Lack of Clear Instructions",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Unexpected Errors or Crashes"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Long Response Times",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Unhelpful or Scripted Responses",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Difficult-to-Find Support Channels"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Frequent Bugs or Downtime",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Complex Updates",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Lack of Engagement or Innovation"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Overly Aggressive Tactics",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Irrelevant Product Suggestions",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Confusing Pricing or Terms"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsxs("td", {
                                                  children: [
                                                    "1.Ignored Feedback",
                                                    JsxRuntime.jsx("br", {}),
                                                    "2.Difficult Feedback Mechanism",
                                                    JsxRuntime.jsx("br", {}),
                                                    "3.Unrewarded Loyalty"
                                                  ],
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        })
                                  ]
                                })
                          ],
                          className: "w-full h-full text-center border-collapse table-fixed px-2 pb-2"
                        }),
                    className: " " + chartHeight + " w-full overflow-y-auto "
                  });
    case "NPS Monthly Cohort" :
        return JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("table", {
                          children: [
                            JsxRuntime.jsx("thead", {
                                  children: JsxRuntime.jsxs("tr", {
                                        children: [
                                          JsxRuntime.jsx("th", {
                                                children: "Joining Month",
                                                className: "py-2 px-4 border-b text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Total Customers",
                                                className: "py-2 px-4 border-b text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Promoters (P)",
                                                className: "py-2 px-4 border-b text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Passives (Pa)",
                                                className: "py-2 px-4 border-b text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Detractors (D)",
                                                className: "py-2 px-4 border-b text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "NPS",
                                                className: "py-2 px-4 border-b text-left"
                                              })
                                        ]
                                      }),
                                  className: "bg-gray-100"
                                }),
                            JsxRuntime.jsxs("tbody", {
                                  children: [
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Jan 2023",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "150",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "90",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "30",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "30",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "40",
                                                  className: "py-2 px-4 border-b bg-custom-gradient"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Feb 2023",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "200",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "120",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "40",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "40",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "40",
                                                  className: "py-2 px-4 border-b bg-custom-gradient"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Mar 2023",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "200",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "70",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "40",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "90",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "15",
                                                  className: "py-2 px-4 border-b bg-custom-red-gradient"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Apr 2023",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "160",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "80",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "50",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "30",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "31.3",
                                                  className: "py-2 px-4 border-b bg-custom-yellow-gradient"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "May 2023",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "190",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "110",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "40",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "40",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "36.8",
                                                  className: "py-2 px-4 border-b bg-custom-gradient"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Jun 2023",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "170",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "85",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "45",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "40",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "26.5",
                                                  className: "py-2 px-4 border-b bg-custom-yellow-gradient"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Jul 2023",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "160",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "90",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "40",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "30",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "37.5",
                                                  className: "py-2 px-4 border-b bg-custom-yellow-gradient"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Aug 2023",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "200",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "68",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "30",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "102",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "19",
                                                  className: "py-2 px-4 border-b bg-custom-red-gradient"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Sep 2023",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "150",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "80",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "40",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "30",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "33.3",
                                                  className: "py-2 px-4 border-b bg-custom-yellow-gradient"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Oct 2023",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "190",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "110",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "50",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "30",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "42.1",
                                                  className: "py-2 px-4 border-b bg-custom-gradient"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Nov 2023",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "200",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "120",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "50",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "30",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "45.0",
                                                  className: "py-2 px-4 border-b bg-custom-gradient"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Dec 2023",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "210",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "130",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "50",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "30",
                                                  className: "py-2 px-4 border-b"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "47.6",
                                                  className: "py-2 px-4 border-b bg-custom-gradient"
                                                })
                                          ]
                                        })
                                  ]
                                })
                          ],
                          className: "w-full h-full text-center border-collapse table-fixed px-2 pb-2"
                        }),
                    className: " " + chartHeight + " w-full overflow-y-auto "
                  });
    case "NPS Shift Report" :
        return JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("table", {
                          children: [
                            JsxRuntime.jsx("thead", {
                                  children: JsxRuntime.jsxs("tr", {
                                        children: [
                                          JsxRuntime.jsx("th", {
                                                children: "Shift",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Jan",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Feb",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Mar",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Apr",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "May",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Jun",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Jul",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Aug",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Sep",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Oct",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Nov",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "Dec",
                                                className: "px-4 py-2 bg-gray-200 text-left"
                                              })
                                        ]
                                      })
                                }),
                            JsxRuntime.jsxs("tbody", {
                                  children: [
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Promoter to Detractor",
                                                  className: "px-4 py-2 border-t border-gray-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "10",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "12",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "8",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "9",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "11",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "10",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "13",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "7",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "15",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "9",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "11",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "14",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-300"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Promoter to Passive",
                                                  className: "px-4 py-2 border-t border-gray-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "4",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "5",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "7",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "6",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "8",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "7",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "9",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "5",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "10",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-500"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "8",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "7",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "9",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-400"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Promoter to Promoter",
                                                  className: "px-4 py-2 border-t border-gray-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "15",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "16",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "17",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "16",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "18",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "19",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "17",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "16",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "18",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "19",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "18",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "17",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Detractor to Promoter",
                                                  className: "px-4 py-2 border-t border-gray-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "5",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "7",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "6",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "8",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "5",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "9",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "7",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "6",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "4",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "8",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "5",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "6",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-200"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Detractor to Passive",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "3",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "4",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "5",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "6",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "4",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "5",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "6",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "3",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "7",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-500"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "5",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "4",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "6",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-400"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Detractor to Detractor",
                                                  className: "px-4 py-2 border-t border-gray-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "12",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "14",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "13",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "11",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "12",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "15",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "14",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "13",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "16",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "14",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "13",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "15",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Passive to Promoter",
                                                  className: "px-4 py-2 border-t border-gray-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "8",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "9",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "10",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "11",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "9",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "10",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "8",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "12",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "11",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "10",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "9",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "11",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-green-200"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Passive to Detractor",
                                                  className: "px-4 py-2 border-t border-gray-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "6",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "5",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "8",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "7",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "6",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "9",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "7",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "10",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "8",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "7",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "8",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "9",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-red-300"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Passive to Passive",
                                                  className: "px-4 py-2 border-t border-gray-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "10",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "11",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "12",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "13",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "11",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "12",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "13",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "14",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "12",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "13",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "12",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "11",
                                                  className: "px-4 py-2 border-t border-gray-300 bg-yellow-100"
                                                })
                                          ]
                                        })
                                  ]
                                })
                          ],
                          className: "w-full h-full text-center border-collapse table-fixed px-2 pb-2"
                        }),
                    className: chartHeight + " w-full overflow-y-auto"
                  });
    case "New Customer Addition - NPS Cohort" :
        return JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("table", {
                          children: [
                            JsxRuntime.jsx("thead", {
                                  children: JsxRuntime.jsxs("tr", {
                                        children: [
                                          JsxRuntime.jsx("th", {
                                                children: "Month of Joining",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "No.New customers",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "1st Month",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "2nd Month",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "3rd Month",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "4th Month",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "5th Month",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "6th Month",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "7th Month",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "8th Month",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "9th Month",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "10th Month",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "11th Month",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              }),
                                          JsxRuntime.jsx("th", {
                                                children: "12th Month",
                                                className: "py-3 px-4 text-left text-gray-700 font-semibold border-b"
                                              })
                                        ]
                                      }),
                                  className: "bg-gray-100"
                                }),
                            JsxRuntime.jsxs("tbody", {
                                  children: [
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Feb 2021",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "2436",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "37.2",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "51.37",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "58.77",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "65.12",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "69.91",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "73.14",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "65.96",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "73.02",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "82.7",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-500"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "85",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-500"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "87.36",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-500"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "90",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-500"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Mar 2021",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "4149",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "38.3",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "47.85",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "54.98",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "60.8",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "64.99",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "68.25",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "60.34",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "69.02",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "77.71",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "79.74",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "81.31",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-500"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Apr 2021",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "2417",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "34.82",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "45.51",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "54.33",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "60.32",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "65.09",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "69.28",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "65.37",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "70.18",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "79.16",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "80.74",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "May 2021",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "2703",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "34.97",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "44.28",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "51.39",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "56.78",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "61.91",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "66.12",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "58.58",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "68.22",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "74.2",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Jun 2021",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "2503",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "32.49",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "44.09",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "45.47",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "51.1",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "54.83",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "57.71",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "45.59",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "58.05",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "July 2021",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "1618",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "33.61",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "44.77",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "54.23",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "60.39",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "65.69",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "70.46",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "45.25",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Aug 2021",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "1654",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "30.81",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "43.07",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "51.4",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "56.84",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "61.73",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "64.2",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Sep 2021",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "2735",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "30.78",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "42.42",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "50.98",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "57.48",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "61.02",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Oct 2021",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "2587",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "35.45",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "44.91",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "52.57",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-200"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "56.06",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-green-100"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Nov 2021",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "1164",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "20.23",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-500"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "28.85",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-500"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "33.55",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Dec 2021",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "659",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "36.15",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "43.05",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-300"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("td", {
                                                  children: "Jan 2022",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "361",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "34.94",
                                                  className: "py-3 px-4 border-b text-gray-800 bg-yellow-400"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                }),
                                            JsxRuntime.jsx("td", {
                                                  children: "",
                                                  className: "py-3 px-4 border-b text-gray-800"
                                                })
                                          ]
                                        })
                                  ]
                                })
                          ],
                          className: "w-full h-full text-center border-collapse table-fixed px-2 pb-2"
                        }),
                    className: " " + chartHeight + " w-full overflow-y-auto "
                  });
    default:
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("table", {
                        children: [
                          JsxRuntime.jsx("thead", {
                                children: $$Array.of_list(List.map((function (x) {
                                            return JsxRuntime.jsx("th", {
                                                        children: JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("p", {
                                                                      children: x
                                                                    }),
                                                                JsxRuntime.jsx("img", {
                                                                      className: "h-16-px mt-2-px ml-4-px",
                                                                      src: Image$ReactHooksTemplate.heading
                                                                    })
                                                              ],
                                                              className: "flex justify-center"
                                                            }),
                                                        className: "p-10-px sticky top-0"
                                                      });
                                          }), TableAttribute$ReactHooksTemplate.headers(attribute))),
                                className: "bg-gray-200 h-10 border rounded text-sm sticky top-0"
                              }),
                          JsxRuntime.jsx("tbody", {
                                children: $$Array.of_list(List.map((function (xs) {
                                            return JsxRuntime.jsx("tr", {
                                                        children: $$Array.of_list(List.map((function (x) {
                                                                    return JsxRuntime.jsx("td", {
                                                                                children: JsxRuntime.jsx("p", {
                                                                                      children: x
                                                                                    }),
                                                                                className: "p-10-px"
                                                                              });
                                                                  }), xs)),
                                                        className: "border rounded border-gray-200"
                                                      });
                                          }), TableAttribute$ReactHooksTemplate.rows(attribute))),
                                className: "font-semibold text-16-px"
                              })
                        ],
                        className: "w-full h-full text-center border-collapse\n              table-fixed px-2 pb-2"
                      }),
                  className: " " + chartHeight + " w-full overflow-y-auto "
                });
  }
}

var make = TableComponent;

exports.make = make;
/* react/jsx-runtime Not a pure module */
